import { render, staticRenderFns } from "./RegistrationsFilters.vue?vue&type=template&id=f51df022&scoped=true&"
import script from "./RegistrationsFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RegistrationsFilters.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RegistrationsFilters.vue?vue&type=style&index=0&id=f51df022&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51df022",
  null
  
)

export default component.exports